import styled from 'styled-components';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Box } from 'components/Box';
import { Link } from 'react-router-dom';
import ArrowBtnFill from 'assets/Buttons/ArrowBtnFill.svg';
import ArrowBtnEmpty from 'assets/Buttons/ArrowBtnEmpty.svg';
import PlayButton from 'assets/Buttons/PlayButton.svg';

export const ArrowStyling = styled(Carousel)`
    height: 650px;
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-top: -90px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin-top: unset;
    }

    ul > li{
        ${({ theme }) => theme.mediaQueries.xs} {
            flex: 1 1 auto;
            position: relative;
            width: 352px;
            margin: auto;
            padding: 0;
            display: flex;
            justify-content: center;
        } 
    }
    & button{
        border-color: ${(props) => props.theme.colors.primary};
        width: 40px;
        height: 40px;
        border-radius: 0px;
    }
    .react-multiple-carousel__arrow--right{
        // background: ${(props) => props.theme.colors.primary};
        background: transparent;
        background-image: url(${ArrowBtnEmpty});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        right: -60px;
        left: 0;
        bottom: 0;
        margin: 0 auto;
        z-index: 0;
    }
    .react-multiple-carousel__arrow--left{
        // background: ${(props) => props.theme.colors.primary};
        background-image: url(${ArrowBtnFill});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        left: -60px;
        bottom: 0;
        margin: 0 auto;
        right: 0;
        z-index: 0;
    }
`

export const CardBody = styled(Box)`
    margin-bottom: 20px;
`

export const CardFooter = styled(Link)`
    background-image: url(${PlayButton});
    height: 52px;
    position: absolute;
    bottom: -75px;
    width: 100%;
`

export const CardFooterNotSelect = styled(Link)`
    background-image: url(${PlayButton});
    height: 52px;
    position: absolute;
    bottom: -75px;
    width: 100%;
    cursor: not-allowed;

    text-decoration: none;
`
export const CardFooterDiable = styled(Link)`
    background-image: url(${PlayButton});
    height: 52px;
    position: absolute;
    bottom: -75px;
    width: 100%;
    pointer-events: none;
    cursor: default;
`